<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col col-lg-6 col-md-6 col-sm-12">

        <h3>Sign In</h3>
        <input type="text" v-model="email" placeholder="Correo"><br>
        <input type="password" v-model="password" placeholder="Contraseña"><br>
        <button @click="login" class="btn btn-lg btn-primary mt-4 btnlogin">Entrar</button>


      </div>
    </div>

  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
name: "Login",
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods:{
    login: function() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            console.log(user);
            this.$router.replace('home')
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
      );
    }
  },
  mounted() {

  }
}
</script>

<style scoped>
.btnlogin {
  width: 100%;
}
input {
  margin: 5px 0;
  width: 100%;
  padding: 15px;
}
p {
  margin-top: 40px;
  font-size: 13px;
}
p a {
  text-decoration: underline;
  cursor: pointer;
}


</style>